export enum FunnelType {
  SALESFORCE = 'salesforce',
  THIRD_PARTY = 'thirdParty',
  RECORD_TYPE = 'recordType',
  HUBSPOT = 'hubspot',
  METADATA_ELEMENT = 'metadataElement',
  STICKY_NOTE = 'stickyNote',
}
